<ppl-auth-message icon="logout-restriction"
                  label="Access Restricted"
                  i18n-label="@@Access_Restricted"
                  [message]="message || defaultMessage"
                  [actionVisible]="actionVisible"
                  [actionLabel]="actionLabel"
                  (action)="onAction()"></ppl-auth-message>
